import React,{useEffect} from "react";
import { Container, Row, Col } from "react-bootstrap";
import CommentIcon from "@material-ui/icons/Comment";
// import BookmarkBorderIcon from "@material-ui/icons/BookmarkBorder";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import parse from "html-react-parser";
import { Skeleton } from "@material-ui/lab";

// image
import prof from "../../assets/images/dummy_profile.jpg";
import TagPills from "../../ui-components/TagPills";
import tw from "../../assets/images/social_Icons/twitter.svg";
import linkin from "../../assets/images/social_Icons/linkedin.svg";
import fb from "../../assets/images/social_Icons/facebook.svg";
import { useHistory } from "react-router-dom";
import Cookies from "universal-cookie";
const Cookie = new Cookies();
function Blogspreview({ props, profileData }) {
  console.log(profileData)
  let history = useHistory();
  var token = Cookie.get("wmtoken");
  const backToLoginPage = () => {
    history.push("/login");
  };
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <React.Fragment>
      {token ? (
        <Container className="py-10 mt-12">
          <Row>
            <Col md={12} className="py-4">
              <h2 className="mb-0 text-5xl">
                {props.question ? (
                  props.question
                ) : (
                  <Skeleton variant="text" height={70} animation="wave" />
                )}
              </h2>
              <h5 className="mb-3 mt-3 text-gray-500">{props.description}</h5>
              <div className="blog_profile_wrapper flex items-center pt-3 border-t ">
                {profileData.userProfilePic ? (
                  <div className="profile_image h-20 w-20 mr-2 rounded-full border bg-white">
                    <Link to="/user">
                      <img
                        src={profileData.userProfilePic}
                        alt="prof"
                        className="blog_profile rounded-full w-full h-full object-cover"
                      />
                    </Link>
                  </div>
                ) : (
                  <Skeleton
                    variant="circle"
                    className="w-16 blog_profile"
                    height={64}
                  />
                )}

                <div className="profile_details leading-4">
                  <div className="profile_top">
                    <Link to="/user">
                      <span className="mr-3 text-black">
                        {profileData.fname} {profileData.lname}
                      </span>
                    </Link>
                    {/* <button className="bg-color-2 py-1 px-3 rounded-2xl text-white">
                      Follow
                    </button> */}
                  </div>
                  {/* <div className="profile_bottom">
                    <span className="text-gray-500 text-sm">May 30</span>
                  </div> */}
                </div>
              </div>
            </Col>
            <Col md={12} className="py-4">
              {props.headImage ? (
                <div className="coverImageBlog">
                  <img
                    src={props.headImage}
                    alt="blogcoverImage"
                    className="blogcoverImage w-100 h-96 object-cover"
                  />
                </div>
              ) : (
                <Skeleton variant="rect" height={518} animation="wave"/>
              )}
            </Col>
            <Col md={12} className="blog_area text-justify">
              {parse(props.content)}
            </Col>

            <Col md={12} className="blog_area blogsFooter">
              <div className="tagsPillsWrapper">
                {props.tags.map((tags, idx) => {
                  return <TagPills key={idx} tags={tags} />;
                })}
              </div>

              <div className="iconsWrapper flex justify-between py-8">
                <div className="leftIconWrapper flex items-center ">
                  <div className="cursor-pointer mr-3">
                    <FavoriteBorderIcon className="mr-2" />
                    <span>0</span>
                  </div>
                  <div className="cursor-pointer mr-3">
                    <CommentIcon className="mr-2" />
                    <span>0</span>
                  </div>
                </div>
                {/* <div className="rightIconWrapper">
                  <div className="socialIconWrapper flex items-center">
                  <a href={void(0)} className="mr-2">
                      <img src={tw} alt="fb" className="w-8" />
                    </a>
                    <a href={void(0)} className="mr-2">
                      <img src={linkin} alt="fb" className="w-8" />
                    </a>
                    <a href={void(0)} className="mr-2">
                      <img src={fb} alt="fb" className="w-8" />
                    </a>
                    <BookmarkBorderIcon className="saveIcon cursor-pointer" />
                  </div>
                </div> */}
              </div>
            </Col>

            {/* <Col md={12} className="blog_area mt-4">
              <MyRespond />
            </Col>
            <Col md={12} className="blog_area mt-4">
              <Comments isLike="true" />
            </Col> */}
          </Row>
        </Container>
      ) : (
        backToLoginPage()
      )}
    </React.Fragment>
  );
}

const mapStateToProps = (state) => {
  return { props: state.blogData, profileData: state.rootData };
};
export default connect(mapStateToProps)(Blogspreview);
